import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNewTheme } from '../../../hooks/useNewTheme';
import { RowDiv, TutoriaisContainer, PageIntro, LibraryHeading, Content, TutorialPlayer } from './tutorialLayout';
import { useTitleAndUser } from '../../../hooks/userTitle';
import { baseURL } from '../../../utils/baseURL';
import { CardVideo } from './components/CardVideo';

interface IPropsVideoData {
  category: number;
  channel: number;
  channelThumbnail: string;
  channelTitle: string;
  comment: [];
  date: Date;
  description: string;
  dislike: [];
  id: number;
  like: [];
  thumbnail: string;
  title: string;
  video_id: string;
  view: [];
}

export function Tutoriais() {
  const { isMobile = false } = useNewTheme() as { isMobile?: boolean };
  //@ts-ignore
  const { setTitle } = useTitleAndUser();
  const [iBoxVideos, setIBoxVideos] = useState<IPropsVideoData[]>([]);

  const [selectedVideo, setSelectedVideo] = useState<IPropsVideoData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTitle('Tutorial');
    getCategoryVideo();
  }, [setTitle]);

  async function getCategoryVideo() {
    await axios
      .get(`${baseURL}/videoscube/api/video/?category__id=2&page_size=1000`)
      .then((response) => {
        let res = response.data;
        res.data = res.data.sort((a: IPropsVideoData, b: IPropsVideoData) => {
          //@ts-ignore
          if (a.date < b.date) return 1;
          if (a.date > b.date) return -1;
          return 0;
        });

        setIBoxVideos(res.data);
        setSelectedVideo(res.data[0] || null);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }
  return (
    <Content $isMobile={isMobile}>
      <TutoriaisContainer>
        <PageIntro>
          <span className="eyebrow">Aprenda a usar o iBox6</span>
          <h1>Tutoriais da plataforma iBox6</h1>
          <p>
          Aqui você encontra vídeos tutoriais curtos e objetivos para aprender a usar todas as funcionalidades da nossa plataforma. Ideal para quem quer começar do zero ou explorar novos recursos.
        </p>
        </PageIntro>
        {loading && <p role="status">Carregando tutoriais...</p>}
        {error && <p role="alert">Não foi possível carregar os tutoriais. Tente novamente mais tarde.</p>}
        {!loading && !error && iBoxVideos.length === 0 && (
          <p>Nenhum tutorial disponível no momento.</p>
        )}
        {selectedVideo && (
          <TutorialPlayer ref={playerRef}>
            <iframe
              key={selectedVideo.video_id}
              title={`Tutorial: ${selectedVideo.title}`}
              src={`https://player-vz-447732c4-8c0.tv.pandavideo.com.br/embed/?v=${encodeURIComponent(selectedVideo.video_id)}&autoplay=true&muted=true`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <div className="player-caption">
              <span className="playing-label">Assistindo agora</span>
              <h2>{selectedVideo.title}</h2>
            </div>
          </TutorialPlayer>
        )}
        {iBoxVideos.length > 0 && (
          <LibraryHeading>
            <div>
              <h2>Explore os tutoriais</h2>
              <p>Escolha um vídeo para aprender no seu ritmo.</p>
            </div>
            <span className="video-count">{iBoxVideos.length} {iBoxVideos.length === 1 ? 'vídeo' : 'vídeos'}</span>
          </LibraryHeading>
        )}
        <RowDiv>
          {iBoxVideos.map((video) => (
            <CardVideo
              key={video.id}
              video={video}
              isTutorial
              isSelected={selectedVideo?.id === video.id}
              handleNewTutorial={(newVideo: IPropsVideoData) => {
                setSelectedVideo(newVideo);
                playerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            />
          ))}
        </RowDiv>
      </TutoriaisContainer>
    </Content>
  );
}
